<script setup lang="ts">
import DevelopmentEnvironmentIndicator from '@booking/components/development/DevelopmentEnvironmentIndicator.vue'
import { getBookingConfig } from '@booking/utils/devEnvironment'

const config = getBookingConfig()
const show = ref(false)
const DevelopmentSettingsDrawer = import.meta.dev
  ? defineAsyncComponent(() => import('./DevelopmentSettingsDrawer.vue'))
  : undefined
</script>

<template lang="pug">
DevelopmentEnvironmentIndicator(v-model:show="show" :appEnv="config.public.APP_ENV" :backendUrl="config.public.BACKEND_URL")
DevOnly
  DevelopmentSettingsDrawer(v-model:show="show")
</template>
